import React from 'react';
import { testimonials } from '../mockData';
import { Quote, Star } from 'lucide-react';

const Testimonials = () => {
  return (
    <section className="bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-[#f4e5c3]/30 rounded-full">
            <span className="text-[#b8962e] font-semibold">Testimonijali</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-[#0f172a] mb-6 gold-underline">
            Što Kažu Naši Klijenti
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Zadovoljstvo naših klijenata je naša najveća nagrada. Pročitajte njihova iskustva.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <Quote className="w-12 h-12 text-[#d4af37] mb-4" />
              
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#d4af37] text-[#d4af37]" />
                ))}
              </div>
              
              <p className="text-gray-700 leading-relaxed mb-6 italic">
                "{testimonial.content}"
              </p>
              
              <div className="border-t border-gray-200 pt-4">
                <p className="font-bold text-[#0f172a]">{testimonial.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;